import React from 'react';
import PropTypes from 'prop-types';
import MessageComponent from './message';
import MessageListRunComponent from './message_list_run';
import BrowserUtils from '../utils/browser';
import StringUtils from '../utils/string';
import moment from 'moment';

class MessageList extends React.Component {
  scrollToBottom() {
    const div = this.scrollable;
    div.scrollTop = div.scrollHeight - div.clientHeight;
  }

  componentDidMount() {
    this.scrollToBottom();
    this._mounted = true;
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  hideMessageList() {
    return (!this._mounted ||
      this.props.newConversation ||
      ((this.props.hasConversations && !this.props.hasActiveConversation) || this.props.searchResultsPresent && !BrowserUtils.isDesktop()));
  }

  message() {
    if (this.props.loading) {
      return (
        <div className="alert-messages loading text-center">
          <p className="t3">Loading...</p>
        </div>
      );
    }

    if (this.props.error.message) {
      return (
        <div className="alert-messages text-danger text-center">
          <p className="t3">
            {this.props.error.message}
          </p>
        </div>
      );
    }

    if (this.props.messages.length === 0) {
      return (
        <div className="row alert-messages">
          <div className="col-sm-8 col-sm-offset-2">
            <p className="t3 mb-30">
              Conversations are private places where you can message one person
              or a group. You will be added automatically to group conversations
              for Vorays you are attending.
            </p>
            <p className="t3 mb-30">
              To start a new conversation, start typing in the search box <span className="visible-xs visible-sm">above</span><span className="hidden-xs hidden-sm">to the left</span>.
            </p>
            <p className="t5">
              Note: You can also message people from their profile page.
            </p>
          </div>
        </div>
      );
    }
  }

  messageList () {
    const rows = [];
    let run = [];
    let prevCreatedAt = null;
    let prevCreator = {};
    let creator;
    let createdAt;
    let messageMoment;
    let formattedDate;

    this.props.messages.forEach(message => {
      creator = message.creator;
      createdAt = message.createdAt;
      messageMoment = moment(createdAt);

      if (creator.id !== prevCreator.id || !messageMoment.isSame(prevCreatedAt, 'd')) {
        rows.push(<MessageListRunComponent key={`run-${message.id}`} run={run} creator={prevCreator} currentUser={this.props.currentUser} isGroupConversation={this.props.isGroupConversation} />);
        run = [];
      }

      run.push(<MessageComponent
        key={message.id}
        user={creator}
        fromCurrentUser={creator.id === this.props.currentUser.id}
        message={message} />);

      if (creator.id !== prevCreator.id) {
        prevCreator = creator;
      }

      if (!messageMoment.isSame(prevCreatedAt, 'd')) {
        formattedDate = StringUtils.formatTimestampForMessageListSeperator(createdAt);

        rows.push(
          <div className="message-list-row" key={createdAt}>
            <div className="message-list-date flex-grow-1 w3">{formattedDate}</div>
          </div>
        );

        prevCreatedAt = messageMoment.startOf('day');
        prevCreator = creator;
      }
    });

    rows.push(<MessageListRunComponent key="last-run" run={run} creator={prevCreator} currentUser={this.props.currentUser} isGroupConversation={this.props.isGroupConversation} />);

    return rows;
  }

  render() {
    const rows = this.messageList();
    const message = this.message();
    const columnClass = this.props.conversationDetailsVisible ? 'col-md-6' : 'col-md-9';
    const emptyClass = this.props.messages.length === 0 && !this.props.loading && 'empty-state';

    return (
        <section className={`${columnClass} ${emptyClass} col-md-offset-3 messages-list`}
          style={this.hideMessageList() ? { display: 'none' } : { bottom: this.props.messageCreatorHeight }}>
          <div className="message-list-contents" ref={node => { this.scrollable = node; }}>
            { message ? message : rows }
          </div>
        </section>
    );
  }
}

MessageList.propTypes = {
  messages: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object.isRequired,
  hasConversations: PropTypes.bool.isRequired,
  hasActiveConversation: PropTypes.bool.isRequired,
  newConversation: PropTypes.bool.isRequired,
  messageCreatorHeight: PropTypes.number.isRequired,
  isGroupConversation: PropTypes.bool.isRequired
};

export default MessageList;
